import i18n from "components/i18n/i18n";
import { NotificationCountData, NotificationCountElement } from "./notificationCount";

const template = document.createElement("template");
template.innerHTML = `
<style>
h2 {
  padding: 0;
  margin: 0;
  font-size: 1.1em;
  font-weight: normal;
  white-space: nowrap;
}

.container {
  padding: 0 .2em;
  margin: .2em;
  background-color: #e2e3e3;
}

</style>
<div class="container">
  <h2></h2>
  <div>
    <slot></slot>
  </div>
</div>
`;
export class NotificationCountGroupElement extends HTMLElement {
  private _shadowRoot: ShadowRoot;
  constructor() {
    super();
    this._shadowRoot = this.attachShadow({ mode: "open" });
    this._shadowRoot.appendChild(template.content.cloneNode(true));
    this._shadowRoot.querySelector("h2").innerHTML = this.getAttribute("title");
  }
  static get observedAttributes() {
    return ["title"];
  }
  private attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "title":
        this._shadowRoot.querySelector("h2").innerHTML = this.getAttribute("title");
    }
  }
  public set counts(counts: NotificationCountData[]) {
    for (const count of counts) {
      let element = (document.createElement("notification-count") as NotificationCountElement);
      let label;
      if (count.translate) {
        label = i18n.t(count.label);
      } else {
        label = count.label;
      }
      element.setAttribute("label", label);
      element.setAttribute("count", count.count.toString());
      element.setAttribute("url", count.url);
      this.append(element);
    }
  }
}

export function initNotificationCountGroupWebComponent() {
  window.customElements.define("notification-countgroup", NotificationCountGroupElement);
}
